module.exports = __webpack_public_path__ + "static/media/signal_cellular_alt_black_24dp 3.8d362f01.svg";